import React from 'react';
import { formatDistanceToNowStrict } from 'date-fns';
import { vi } from 'date-fns/locale';
import CommentAvatar from './CommentAvatar';
import ReplyItem from './ReplyItem';
import CommentBox from './CommentBox';
import rankName from '../../utils/user/rankName';
// Dùng chung renderer với nội dung bài Kênh Cộng Đồng: link trong bình luận
// (nhất là QTV trả lời kèm link) phải bấm được, không còn là text thuần.
import { renderLinkified } from '../../pages/Community/community-linkified-text';
import { threadNames } from './comment-mention';

function CommentItem({
    comment,
    isLogined,
    userInfo,
    isHighlighted,
    highlightReplyId,
    onOpenReply,
    onDeleteComment,
    onDeleteReply,
    newReply,
    setReply,
    onSubmitReply,
}) {
    const isAdmin = comment.user?.role === 'admin';
    // User không được xoá/sửa bình luận của mình sau khi gửi — chỉ admin xoá được.
    const canDelete = isLogined && userInfo.role === 'admin';
    // Tên có thật trong luồng → dùng để nhận diện "@Tên" đứng đầu nội dung reply
    const knownNames = threadNames(comment);

    return (
        <div
            id={`comment-${comment.commentId}`}
            className={`flex gap-2 p-2 rounded-2xl transition-colors duration-700 ${
                isHighlighted ? 'bg-primary-50' : ''
            }`}
        >
            <CommentAvatar avatar={comment.user?.avatar} isAdmin={isAdmin} size="md" />
            <div className="flex-1 min-w-0 flex flex-col gap-1">
                <div
                    className={`inline-block max-w-full rounded-2xl px-3 py-2 ${
                        isAdmin ? 'bg-amber-50 border border-amber-200' : 'bg-surface-muted'
                    }`}
                >
                    <div className="flex flex-wrap gap-1 items-center">
                        <span className="font-semibold text-sm text-content">
                            {comment.user?.name ||
                                `user-${comment.user?.userId || 'unknown'}`}
                        </span>
                        <span className="text-xs">
                            {isAdmin ? rankName(888) : rankName(comment.user?.rank ?? 0)}
                        </span>
                    </div>
                    <p className="text-sm text-content-2 whitespace-pre-wrap break-words">
                        {renderLinkified(comment.comment)}
                    </p>
                </div>

                <div className="flex items-center gap-1 px-1">
                    <span className="text-xs text-content-3 mr-1">
                        {formatDistanceToNowStrict(comment.createTime, { locale: vi })}
                    </span>
                    {isLogined && (
                        <>
                            <button
                                type="button"
                                /* Prefill "@Tên" như khi trả lời một reply —
                                   người đọc thấy ngay trả lời nhắm tới ai */
                                onClick={() =>
                                    onOpenReply(comment.commentId, comment.user?.name)
                                }
                                className="text-xs text-content-3 hover:text-primary-500 font-medium px-1.5 py-1.5 rounded"
                            >
                                Trả lời
                            </button>
                            {canDelete && (
                                <button
                                    type="button"
                                    onClick={() => onDeleteComment(comment.commentId)}
                                    className="text-xs text-content-3 hover:text-primary-500 font-medium px-1.5 py-1.5 rounded"
                                >
                                    Xoá
                                </button>
                            )}
                        </>
                    )}
                </div>

                {comment.replies.length > 0 && (
                    /* Thụt hẳn vào trong + đường dọc đậm hơn (kiểu Facebook) để
                       thấy rõ đây là các trả lời thuộc bình luận phía trên.
                       Mỗi ReplyItem tự vẽ thêm "khuỷu" nối ngang vào đường này. */
                    <div className="flex flex-col gap-1 pl-5 sm:pl-8 border-l-2 border-line">
                        {comment.replies.map((reply) => (
                            <ReplyItem
                                key={reply.id}
                                reply={reply}
                                commentId={comment.commentId}
                                isLogined={isLogined}
                                userInfo={userInfo}
                                isHighlighted={highlightReplyId === String(reply.id)}
                                onOpenReply={onOpenReply}
                                onDeleteReply={onDeleteReply}
                                knownNames={knownNames}
                            />
                        ))}
                    </div>
                )}

                {comment.isOpenReply && (
                    <div className="pl-5 sm:pl-8">
                        <CommentBox
                            value={newReply}
                            setValue={setReply}
                            onSubmit={onSubmitReply}
                            autoFocus
                            avatar={userInfo?.avatar}
                            placeholder="Viết trả lời..."
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default CommentItem;
